import React from "react";
import styled from "styled-components";

const SectionMenu = () => {
  return (
    <SectionMenuStyle>
      {/* <CommonContainer> */}
      <div>
        <ul>
          <li id="kbAddOneFramework-nav" className="active">
            <a href="#kbAddOneFramework">KB Add One Framework</a>
          </li>
          <li id="kbImms-nav">
            <a href="#kbImms">KB 통합유지보수 플랫폼</a>
          </li>
          <li id="kbPms-nav">
            <a href="#kbPms">KB플랜잇 프로젝트 관리시스템</a>
          </li>
          <li id="liveCare-nav">
            <a href="#liveCare">LiveCare 화상상담 시스템</a>
          </li>
          <li id="kbIssueReporter-nav">
            <a href="#kbIssueReporter">KB 이슈리포터</a>
          </li>
          <li id="msp-nav">
            <a href="#msp">통합 MSP 포털</a>
          </li>
        </ul>
      </div>
      {/* </CommonContainer> */}
    </SectionMenuStyle>
  );
};

export default SectionMenu;

const SectionMenuStyle = styled.div`
  position: absolute;
  z-index: 999;
  height: 91%;
  left: 0px;
  top: 80vh;
  /* & > div {
        position: relative;
        height: 100%;
    } */
  & > div {
    padding-top: 190px;
    position: absolute;
    height: 100%;
    //width: 150px;
    left: 0px;
    top: 0px;
  }
  & > div > ul {
    position: sticky;
    top: 150px;
  }
  & > div > ul > li {
    margin-bottom: 27px;
    padding-left: 50px;
  }
  & > div > ul > li:last-child {
    margin-bottom: 0px;
  }
  li.active {
    position: relative;
    :before {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      margin-top: -1px;
      left: 0px;
      width: 37px;
      height: 2px;
      background: #ffbc00;
    }
  }
  li.active > a {
    color: #ffbc00;
    font-weight: 600;
  }
  li > a {
    display: block;
    width: max-content;
    color: #bfbfbf;
    font-size: 16px;
    text-decoration: none;
  }
  @media ${(props) => props.theme.tablet} {
    display: none;
  }
`;
